import * as React from "react";
import { forwardRef } from "react";
function SvgGarageHomeFilled(props, ref) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: 24, viewBox: "0 -960 960 960", width: 24, "data-testid": "GarageHomeFilledIcon", fill: "currentColor", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M160-120v-480l320-240 320 240v480H680v-400H280v400H160Zm200-80h240v-80H360v80Zm0-160h240v-80H360v80Z" }));
}
const ForwardRef = forwardRef(SvgGarageHomeFilled), GarageHomeFilled = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgLTk2MCA5NjAgOTYwIiB3aWR0aD0iMjQiPjxwYXRoIGQ9Ik0xNjAtMTIwdi00ODBsMzIwLTI0MCAzMjAgMjQwdjQ4MEg2ODB2LTQwMEgyODB2NDAwSDE2MFptMjAwLTgwaDI0MHYtODBIMzYwdjgwWm0wLTE2MGgyNDB2LTgwSDM2MHY4MFoiLz48L3N2Zz4=";
export {
  ForwardRef as ReactComponent,
  GarageHomeFilled as default
};
//# sourceMappingURL=GarageHomeFilled.js.map
